import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import CommonService from "../../services/common.service";
import Select from "react-select";
import Loader from "../Common/Loader";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const UserPreference = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userGames, setUserGames] = useState([]);
  const [gameId, setGameId] = useState(0);
  const [menus, setMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(0);
  const [preferenceDetails, setPreferenceDetails] = useState({});

  useEffect(() => {
    Promise.all([
      CommonService.getUserGames(),
      CommonService.getUserMenuData(),
      CommonService.getUserPreferenceDetails(),
    ]).then(([gamesRes, menuRes, prefRes]) => {
      if (gamesRes.success) {
        setUserGames(gamesRes.data);
      }
      if (menuRes.success) {
        setMenus(menuRes.data);
      }
      if (prefRes.success) {
        setPreferenceDetails(prefRes.data);
        setGameId(prefRes.data.game_id); // prefill game
        setSelectedMenu(prefRes.data.menu_id); // prefill menu
      }
      setIsLoading(false);
    });
  }, []);
  const navigate = useNavigate();
  const checkUserPreferenceExists = () => {
    CommonService.setGameUserPreference().then((res) => {
      if (res.success) {
        localStorage.setItem("club_details", JSON.stringify(res.data));
        localStorage.setItem("branding", JSON.stringify(res.branding));
        window.location.href = res.menu_url;
      } else {
        navigate("/my-games");
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to change your default upon login?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Save it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          gameId: gameId,
          menu_id: selectedMenu,
        };
        CommonService.saveUserPreference(formData).then((res) => {
          if (res.success) {
            Swal.fire("Saved!", res.message, "success");
            checkUserPreferenceExists();
          } else {
            Swal.fire("Error!", res.message, "error");
          }
        });
      }
    });
  };
  const resetPreference = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Reset?",
      text: "Your default will be reset to My Games.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          gameId: gameId,
          menu_id: 1, // default menu ID
        };
        CommonService.saveUserPreferenceToDefault(formData).then((res) => {
          if (res.success) {
            Swal.fire("Reset!", res.message, "success");
            navigate("/my-games");
          } else {
            Swal.fire("Oops!", res.message, "error");
          }
        });
      }
    });
  };
  return isLoading ? (
    <Loader />
  ) : (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>My Preferences</h2>
          </div>

          <div>
            <div className="whitebox">
              <div className="playerprofile-section">
                <div className="loginform">
                  <div className=" text-left mb-3">
                    <em>
                      Select a default landing page from your preferred game to
                      personalize your experience each time you log in.{" "}
                    </em>
                    {Object.keys(preferenceDetails).length === 0 && (
                      <em>
                        Current Default Upon Login:{" "}
                        <Link to={"/my-games"}>My Games </Link>{" "}
                      </em>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="fantasy_hub" className="pb-2 fw-bold">
                          My Games*
                        </label>
                        <Select
                          options={userGames}
                          isSearchable={true}
                          placeholder="Select a game"
                          value={
                            userGames.find((g) => g.value === gameId) || null
                          } // pre-select
                          onChange={(option) => setGameId(option.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group pb-2">
                        <label htmlFor="team_name" className="pb-2 fw-bold">
                          My Default Upon Login*
                        </label>
                        <select
                          className="form-control"
                          value={selectedMenu}
                          onChange={(e) => setSelectedMenu(e.target.value)}
                        >
                          <option value={0}>Select a default game page</option>
                          {menus.map((menu) => (
                            <option key={menu.id} value={menu.id}>
                              {menu.menu_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-4">
                      {" "}
                      {gameId !== 0 && (
                        <button
                          onClick={handleSubmit}
                          className="btn btn-primary mr-3"
                        >
                          Save
                        </button>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-4"></div>
                    <div className="col-sm-12 col-md-4">
                      {" "}
                      {gameId !== 0 && (
                        <button
                          onClick={resetPreference}
                          className="btn btn-primary"
                        >
                          Reset
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPreference;
